import { useSetCustomToken } from '@btime/react-session'
import React from 'react'

import { getAuthToken } from '../../../utils/session/sessionStorage'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import SessionTokenForAutofillContext from './_context/SessionTokenForAutofillContext'
import ExecutionFormHandler from './_form/ExecutionDynamicServiceOrdersHandler'
import DynamicServiceOrdersLoader from './_load/DynamicServiceOrdersLoader'
import PageContent from './PageContent'

const DynamicServiceOrderExecutionPage = ({ shareCode }) => {
  const sessionTokenRef = React.useRef(undefined)
  if (sessionTokenRef.current === undefined) {
    sessionTokenRef.current = typeof window !== 'undefined' ? getAuthToken() : null
  }
  const sessionTokenForAutofill = sessionTokenRef.current

  useSetCustomToken('formToken', shareCode)

  return (
    <SessionTokenForAutofillContext.Provider value={sessionTokenForAutofill}>
      <AbsolutePageTemplate>
        <DynamicServiceOrdersLoader shareCode={shareCode}>
          <ExecutionFormHandler>
            <PageContent />
          </ExecutionFormHandler>
        </DynamicServiceOrdersLoader>
      </AbsolutePageTemplate>
    </SessionTokenForAutofillContext.Provider>
  )
}

export default DynamicServiceOrderExecutionPage
